import {useGlobals} from '../../globalPropsContext';

export const useCategories = () => {
  const {useCategories: _useCategories} = useGlobals();
  return _useCategories;
};
